<template>
  <div>
    <div class="xc-page xc-page-sandwich">
      <div class="xc-page-main">
        <!-- 面包屑 -->
        <div class="xc-breadcrumb">
          <router-link :to="$config.adminPath + '/device'">终端管理</router-link>
          <router-link :to="$config.adminPath + '/device/apk'">APK管理</router-link>
          <a>手动升级</a>
        </div>
        <xc-step :step-value="stepValue"></xc-step>
        <!-- 选择终端 -->

        <div class="xc-row xc-s-flex" style="overflow: auto" v-if="currentStep == 0">
          <div class="xc-card xc-s-df">
            <div class="device-group">
              <div class="xc-card-header">
                <div class="xc-card-title">
                  终端组
                  <span>点击右键操作更多</span>
                </div>
              </div>
              <!-- 树形目录 -->
              <div class="tree xc-s-p" style="overflow: auto;">
                <xc-tree :data.sync="deviceGroups" label="name" @checked="deviceGroupChecked" show-checkbox linked
                  :expand="0" multiple :key="deviceGroups.length"></xc-tree>
              </div>
            </div>
            <!-- 隐藏的数据 -->
            <span style="display:none;">{{ selectCount }}</span>
            <!--  带滚动条表格 -->
            <div class="xc-row xc-s-flex" style="overflow: auto;">
              <div class="xc-card">
                <div class="xc-card-content">
                  <form class="xc-form">
                    <div class="xc-form-inline">
                      <xc-form-item label="终端名">
                        <input type="text" maxlength="255" class="xc-input" placeholder="请输入终端名称"
                          v-model="search.deviceName">
                      </xc-form-item>
                      <xc-form-item label="在线状态">
                        <select class="xc-select" v-model="search.deviceStatus">
                          <option value=''>全部</option>
                          <option value='0'>在线</option>
                          <option value='1'>离线</option>
                        </select>
                      </xc-form-item>
                      <div class="form-item-group" style="margin-right:20px;">
                        <select class="xc-select" v-model="searchType" style="width:100px;margin-right:10px">
                          <option value="mac">mac</option>
                        </select>
                        <input type="text" maxlength="255" class="xc-input" placeholder="请输入" v-if="searchType == 'mac'"
                          v-model="search.deviceMac">
                      </div>
                      <div class="xc-btn-group">
                        <button type="submit" class="xc-btn xc-btn-primary" @click.prevent="getList()">查询</button>
                      </div>
                    </div>

                    <div class="xc-form-inline">
                      <xc-form-item class="xc-s-flex">

                      </xc-form-item>
                    </div>
                  </form>
                  <!-- 带滚动条的表格 -->
                  <div class="xc-row-scroll">
                    <table class="xc-table">
                      <thead>
                        <tr>
                          <th>
                            <input type="checkbox" class="xc-checkbox" :checked="checkAll" @change="checkAllChange">
                          </th>
                          <th>终端名</th>
                          <th>设备IP</th>
                          <th>设备MAC</th>
                          <th>门店名</th>
                          <th>在线状态</th>
                          <th>设备类型</th>
                          <th>设备尺寸</th>
                          <th>分辨率</th>
                          <th>机型</th>
                          <th>安装位置</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="list && list.length">
                          <tr v-for="(item, key) in list" :key="key">
                            <td style="width: 45px;">
                              <input type="checkbox" class="xc-checkbox" :checked="selectDevice[item.deviceCode]"
                                @change="deviceChecked(item)">
                            </td>
                            <td>{{ item.deviceName }}</td>
                            <td>{{ item.lastReportIp }}</td>
                            <td>{{ item.deviceMac }}</td>
                            <td>{{ item.storeName }}</td>
                            <td>{{ item.deviceStatus }}</td>
                            <td>{{ item.deviceType }}</td>
                            <td>{{ item.screenSize }}</td>
                            <td>{{ item.resolvingPower }}</td>
                            <td>{{ item.model }}</td>
                            <td>{{ item.deviceLocation }}</td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td colspan="9" class="xc-s-tac">请选择终端</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  终端确认 -->
        <div class="xc-row xc-s-flex" style="overflow: hidden;" v-if="currentStep == 1">
          <div class="xc-card">
            <div class="xc-card-content">
              <div class="xc-form-inline xc-form-inline-resete">
                <div>
                  APK名称：{{ apkDetail.upgradeName }}，升级版本：{{ apkDetail.versionName }}，是否定时升级时间：{{ apkDetail.timingTime ? '是' : '否' }}
                  <span v-if="apkDetail.timingTime">，时间时间：{{ apkDetail.timingTime | moment }}</span>
                </div>
                <div>共{{ selectCount }}条数据预览、共{{ groupCount }}组、{{ selectCount }}终端、经办人：{{ apkDetail.uploader }}</div>
              </div>
              <!-- 带滚动条的表格 -->
              <div class="xc-row-scroll">
                <table class="xc-table">
                  <thead>
                    <tr>
                      <th>终端组</th>
                      <th>终端名</th>
                      <th>设备IP</th>
                      <th>设备MAC</th>
                      <th>在线状态</th>
                      <th>设备类型</th>
                      <th>设备尺寸</th>
                      <th>分辨率</th>
                      <th>机型</th>
                      <th>安装位置</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="selectDeviceArray && selectDeviceArray.length">
                      <tr v-for="(item, key) in selectDeviceArray" :key="key">
                        <td>{{ item.groupName }}</td>
                        <td>{{ item.deviceName }}</td>
                        <td>{{ item.lastReportIp }}</td>
                        <td>{{ item.deviceMac }}</td>
                        <td>{{ item.deviceStatus }}</td>
                        <td>{{ item.deviceType }}</td>
                        <td>{{ item.screenSize }}</td>
                        <td>{{ item.resolvingPower }}</td>
                        <td>{{ item.model }}</td>
                        <td>{{ item.deviceLocation }}</td>
                        <td class="xc-link">
                          <a @click="deviceChecked(item)">删除</a>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="9 " class="xc-s-tac">暂无数据</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="xc-row xc-s-flex" style="overflow: hidden;" v-if="currentStep == 2">
          <div class="xc-card xc-device-apk">
            <div class="xc-card-content xc-device-apk-complete">
              <div class="xc-form-inline">
                <div>
                  <img src="../assets/success.png" v-if="upSuccess">
                  <img src="../assets/fail.png" v-else>
                  <div class="xc-device-apk-success">{{ upSuccess ? '升级成功!' : '升级失败!' }}</div>
                  <div>共{{ selectCount }}条数据，成功下发{{ groupCount }}分组{{ selectCount }}个设备</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- 固低栏 -->
      <div class="xc-page-footer">
        <div class="xc-btn-group">
          <div class="xc-btn xc-btn-default" @click="preStep" v-if="currentStep == 1">上一步</div>
          <div class="xc-btn xc-btn-primary" @click="nextStep" v-if="currentStep == 0">下一步</div>
          <div class="xc-btn xc-btn-primary" @click="nextStep" v-if="currentStep == 1">升级</div>
          <router-link class="xc-btn xc-btn-primary" :to="$config.adminPath + '/device/apk'"
            v-if="currentStep == 2">完成</router-link>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import deviceApi from '@/api/device'

export default {
  name: 'deviceApkUpgrade',
  data() {
    return {
      currentStep: 0,
      stepValue: [
        {
          text: "选择终端",
          active: true,

        },
        {
          text: "终端确认"
        },
        {
          text: "升级完成"
        }
      ],

      // 列表
      list: [],

      // 终端分组
      deviceGroups: [],

      // 弹出窗
      modalName: null,

      // 搜索类型
      searchType: 'mac',

      // 搜索
      search: {
        deviceStatus: '',
      },

      // 选择的终端
      selectDevice: {},

      groupCount: 0,

      // apk升级详情
      apkDetail: {},

      // 是否升级成功
      upSuccess: false
    };
  },

  created() {
    deviceApi.getDeviceGroup().then((v) => {
      this.deviceGroups = v.data;
    })

    deviceApi.getApkById({ deviceUpgradeId: this.$route.params.deviceUpgradeId }).then((v) => {
      this.apkDetail = v.data;
      this.search.belowSoftVersion = v.data.versionCode;

      this.getList();
    })
  },

  methods: {
    // 初始化数据
    getList(checkAll) {
      // 默认搜索的数据
      const search = {
        pageNum: 1,
        pageSize: 0,
        ...this.search
      };

      deviceApi.getDeviceList(search).then(ret => {

        const list = ret.data.list;
        // 全选
        if (checkAll) {
          const selectDevice = {
            ...this.selectDevice,
          }

          list.map(item => {
            selectDevice[item.deviceCode] = item;
          })

          this.selectDevice = selectDevice;
        }


        this.list = list;
      })

    },

    /**
     * 终端分组选择
     */
    deviceGroupChecked(tree) {
      const { checked } = tree;

      const groupId = [];

      checked.map(item => {
        groupId.push(item.id)
      })

      this.search.groupId = groupId.join(',');

      if (this.search.groupId == '') {
        this.selectDevice = {};
        return;
      }

      // 终端分组选中的时候全选数据
      const checkAll = true;
      this.getList(checkAll);
    },

    // 下一步
    nextStep() {
      let stepLen = this.stepValue.length;
      let cur = this.currentStep;

      const next = () => {
        if (cur < stepLen - 1) {
          this.$set(this.stepValue[cur + 1], "active", true);
        }

        this.$set(this.stepValue[cur], "complete", true);

        // if (cur == stepLen - 2) {
        //     this.$set(this.stepValue[cur + 1], "complete", true);
        // }

        this.currentStep++;
      }

      if (cur == 0) {
        if (!this.selectCount) return this.$message.error('请选择需要升级的终端');
      }
      else if (cur == 1) {
        const deviceCodes = this.selectDeviceArray.map((v) => {
          return v.deviceCode;
        })

        deviceApi.upgradeApkToMips({
          deviceCodes: deviceCodes.join(','),
          deviceUpgradeId: this.$route.params.deviceUpgradeId,
        }).then(v => {
          this.upSuccess = true
          next();
        })

        return;
      }

      if (cur >= stepLen) {
        // 结束操作
        return;
      }

      next();

    },

    // 上一步
    preStep() {
      let stepLen = this.stepValue.length;
      let cur = this.currentStep;
      if (cur <= 0) {
        // 结束操作
        return;
      }
      if (cur > -1 && cur < stepLen) {
        this.$set(this.stepValue[cur], "active", false);
      }

      this.$set(this.stepValue[cur - 1], "complete", false);
      this.currentStep--;
    },

    // 设备选中
    deviceChecked(item) {
      const selectDevice = {
        ...this.selectDevice,
      }

      if (selectDevice[item.deviceCode]) {
        delete selectDevice[item.deviceCode];
      } else {
        selectDevice[item.deviceCode] = item;
      }

      this.selectDevice = selectDevice;
    },


    checkAllChange() {

      const selectDevice = {
        ...this.selectDevice,
      }

      this.list.map(item => {
        if (this.checkAll) {
          delete selectDevice[item.deviceCode];
        } else {
          selectDevice[item.deviceCode] = item;
        }
      })

      this.selectDevice = selectDevice;
    }

  },
  computed: {
    // 是否全选
    checkAll() {
      if (Object.keys(this.selectDevice).length == 0 || this.list.length == 0) {
        return false;
      }

      // 判断是否有没有选中的数据
      let notAll = this.list.some((item) => {
        return this.selectDevice[item.deviceCode] == undefined;
      })

      return notAll ? false : true;
    },

    selectCount() {
      const selectCount = Object.keys(this.selectDevice).length;

      this.stepValue[0].text = `选择终端(${selectCount})`;

      return selectCount;
    },


    selectDeviceArray() {

      // 计算一下分组数量
      const groupCount = {};

      const selectDeviceArray = Object.keys(this.selectDevice).map(key => {

        const item = this.selectDevice[key];

        groupCount[item.groupName] = item.groupName;

        return item;
      })

      this.groupCount = Object.keys(groupCount).length;

      return selectDeviceArray;
    }
  },
};
</script>

<style scoped lang="scss">
.xc-device-apk {
  display: flex;
  align-items: center;
  justify-content: center;
}

.xc-device-apk-complete {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.xc-device-apk-success {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 2px;
}

.xc-form-inline-resete {
  display: block;
}
</style>
